import Vue from 'vue'
import element from './element/index.js'
import App from './App.vue'
import routes from './routes/index'
import VueRouter from 'vue-router'
import { install as base } from './assets/js/base/base' // 自定义组件
import store from './store'
import util from './utils/util.js'
// 全局配置
import GlobalConfig from '@/config'
import { basePrefix } from '@/../config'
// css 样式
import mainCss from './assets/css/main.css'
import commonCss from './assets/css/common.css'
import ioamCss from './assets/css/ioam.css'
import notification from './utils/notification'
import components from '@/components/index.js'
import { messages, keys } from './utils/messages'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { DomMessage } from './utils/messageDeduplication'
import { localStorages, sessionStorages } from './utils/localStorages'
import config from '@/config/axiosConf'
import { logoutDelay } from './utils/logout'
import encryptUtil from './utils/gatewayEncrypt'
import systemEnterUtil from './utils/enterSystem'
import fabric from 'fabric'
Vue.use(fabric);

NProgress.configure({ showSpinner: false, speed: 500 });

messages.use(store)

Vue.use(base)
Vue.use(VueRouter)
Vue.use(element)
Vue.use(notification)
Vue.use(util)
// css
Vue.use(mainCss)
Vue.use(commonCss)
Vue.use(ioamCss)
Vue.use(components)
Vue.prototype.$message = new DomMessage()
Vue.prototype.$localStorage = localStorages
Vue.prototype.$sessionStorage = sessionStorages
Vue.prototype.encryptUtil = encryptUtil
Vue.prototype.uploadHeaders = {
  "X-enc-key": encryptUtil.getHeader(),
  "X-enc-esp-body": true
}
Vue.prototype.$getSystemUrl = systemEnterUtil.getSystemUrl

window.onbeforeunload = function() {
  let tabkey = sessionStorages.getItem('tabkey')
  let connKey = localStorages.getItem('connKey')
  let peopleId = localStorages.getItem('peopleId')
  console.log(store.state.ws)
  store.state.ws.forEach(item => {
    item.send(JSON.stringify({
      code: 1002,
      connKey: connKey,
      tabkey: tabkey,
      peopleId: peopleId
      }))
  })
}

function getImgPath(path) {
  if (config.security) {
    // 请求资源前加密
    // const res = await axios.get(`${encryptUtil.getEncryptedString(binding.value)}`)
    // imgURL = window.URL.createObjectURL(new window.Blob([res.data]))
    return `${Vue.prototype.FileThumbBase}${encodeURIComponent(encryptUtil.getEncryptedString(path))}?X-enc-key=${encryptUtil.getHeader()}`
  } else {
    return `${Vue.prototype.FileUploadBase_entry}${path}` // 获取图片地址
  }
}

Vue.prototype.getImgPath = getImgPath

Vue.prototype.validForbid = function (value) {
  // value = value.replace(/[\\`[\]~!@#$%^&*()_\-+=<>?:"{}|,./;'·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  value = value.replace(/[^0-9a-zA-Z\u4e00-\u9fa5]/g, '');
  return value;
}

/**
* 检测图片是否存在
* @param url
*/
let imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete === true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

// import Axios from 'axios'
// const axios = Axios.create({
//   baseURL: config.FileThumbBase,
//   responseType: 'blob',
//   timeout: 30000,
//   headers: {
//     "X-enc-key": encryptUtil.getHeader()
//   }
// })

// 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
  if (binding.value) {
    // binding.value = 'group1/M00/5D/88/wKgVf2GI20mADCn_AARdJtWDRQw65.jpeg'
    let imgURL = getImgPath(binding.value)
    console.log(imgURL, 'imgURL')
    if (binding.value !== undefined) {
      let exist = await imageIsExist(imgURL)
      if (exist) {
        el.setAttribute('src', imgURL)
      }
      // window.URL.revokeObjectURL(imgURL)
    }
  }
})
// 全局注册自定义指令，绑定函数，点击元素外时触发
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.event = function(event) {
      console.log(el, event.target, 'click-outside');
      // 检查点击是否发生在节点之内（包括子节点）
      if (!(el === event.target || el.contains(event.target))) {
        // 如果没有，则触发调用
        // 若绑定值为函数，则执行
        if (typeof vnode.context[binding.expression] === 'function') {
          vnode.context[binding.expression](event);
        }
      }
    };
    // 绑定事件
    // 设置为true，代表在DOM树中，注册了该listener的元素，会先于它下方的任何事件目标，接收到该事件。
    document.body.addEventListener("click", el.event, true);
  },
  unbind: function(el) {
    // 解绑事件
    document.body.removeEventListener("click", el.event, true);
  }
})
// 滚动加载
Vue.directive('loadMore', {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function() {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})

// 路由初始化 history模式
var router = new VueRouter({
  mode: 'history',
  base: basePrefix,
  routes: routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

Vue.use(GlobalConfig, { router, store })

// 路由启用
const app = new Vue({
  router,
  store,
  data () {
    return {
      httpStatus: '',
      httpMsg: '',
      httpType: ''
    }
  },
  // 监听路由检查登录
  watch: {
    '$route': {
      handler() {
        this.checkLogin();
      }
    },
    'httpStatus': 'showMsg'
  },
  created () {
    this.$store.subscribeAction(this.handleActionMsg)
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      // 检查是否存在id_token
      // console.log(process.env.NODE_ENV, '>>>>>>>>>>>>>>>>>>>>')
      const url = this.$route.path
      console.log(url, 'main url')
      if (url === '/' || url === '/login' || url === '/forgetword') {
        return
      }
      if (!this.$localStorage.getItem("id_token") || (url.indexOf('index') > -1 && !this.$route.query['id_token'] && !this.$localStorage.getItem("id_token"))) {
        // 如果没有登录状态则跳转到登录页
        this.$message.warning('请先登录')
        this.$router.push("/login")
      } else {
        this.checkTenant()
      }
    },
    checkTenant() {
      // 检查是否选择租户
      const url = this.$route.path
      if (url.indexOf('login') === -1 && url.indexOf('logout') === -1 && url.indexOf('chooseTenant') === -1) { // 除登录、登出、选择租户以外的页面，选择确定的某一个租户
        let tenantId = this.$localStorage.getItem("tenantId");
        if (!tenantId) { // 未选择租户，或者租户信息为falsy（会不停跳回选择页面，需要接口做限制）
          this.$message.warning('请先选择租户');
          this.$router.push("/chooseTenant");
        }
      }
    },
    handleActionMsg (action, state) {
      if (action.type === keys.appMsg) {
        let msg = action.payload
        switch (msg.code) {
          case messages.nologininfo.code:
          case messages.tokeninvalidate.code:
          case messages.unauthorized.code:
          case messages.unhealthyserver.code:
            /* const refreshToken = this.$localStorage.getItem('refresh_token') */
            /* getNewToken({
              refresh_token: refreshToken
            }).then(res => {
              if (res.data.status === 200 && res.data.code === 100001) {
                this.savecookie('id_token', res.data.token, 1)
                this.$localStorage.setItem('id_token', res.data.token)
                this.$localStorage.setItem('id_token', res.data.token)
              }
            }) */
            window.formChanged = false; // 防止数据未保存时弹出确认框
            logoutDelay()
            break
          default:
            break
        }
        console.warn('global message >>>>>> ', msg)
        console.log(msg, 'main msg')
        this.$message.warning(msg.message) // 改写的DomMessage里，传入的是message字符串
      }
    },
    showMsg () {
      // this.$message({
      //   message: this.httpMsg,
      //   type: this.httpType
      // })
      this.$message[this.httpType](this.httpMsg);
    }
    // removelocalStorage () {
    //   const url = this.$route.path
    //   if (url.indexOf('login') !== -1) {
    //     this.$localStorage.removeItem('id_token')
    //     this.$localStorage.removeItem('refresh_token')
    //     this.$localStorage.removeItem('userId')
    //   }
    // }
  },
  render: h => h(App)
}).$mount('#app')

export default app



// WEBPACK FOOTER //
// ./src/main.js